function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './CurrencySelector.css';
import React, { useRef, useContext, useState, useEffect, useMemo } from 'react';
import Select from 'react-select';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { getColorByTheme, getPageThemeColors, hexToRgb, get, canUseDOM } from '../../../utils';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
import { LOCAL_STORAGE_APP_CURRENCY } from '../constants';
const reactSelectSingleUiSettings = _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS), {}, {
  components: _objectSpread(_objectSpread({}, BASE_SINGLE_SELECT_PROPS.components), {}, {
    IndicatorsContainer: () => null
  })
});
const CurrencySelector = _ref => {
  let {
    changeCurrency,
    changeCurrencyName,
    currencyName,
    currencies,
    rtl,
    themeVariables
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const [highLightField, setHighLightField] = useState(false);
  const [fieldOpened, setFieldOpened] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const clickedFieldRef = useRef(false);
  const apiURL = process.env.STORYBOOK_MODE ? 'https://visitdubai.com' : get(sitecoreContext, 'origin');
  const [isVdsite, setIsVdsite] = useState(true);
  const colorSettings = useMemo(() => {
    if (themeVariables) {
      const values = Object.values(themeVariables);
      return {
        '--component-background-color': values[0],
        '--component-background-color-rgb': values[1],
        '--component-background-active-color': values[2],
        '--component-color': values[3]
      };
    }
    return {
      '--component-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      '--component-background-color-rgb': hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
      '--component-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
      '--component-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
    };
  }, [themeVariables, isVdsite, primaryPageThemeColor, primaryActivePageThemeColor]);
  const options = useMemo(() => {
    return currencies.map(currency => {
      const currencyShort = get(currency, 'currencyId.jss.value');
      const icon = get(currency, 'icon.jss.value.src');
      return {
        label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
          src: icon,
          alt: currencyShort,
          width: "25",
          height: "25"
        }), /*#__PURE__*/React.createElement("span", null, currencyShort)),
        value: currencyShort
      };
    });
  }, [currencies]);
  useEffect(() => {
    if (!currencyName) return;
    if (currencyName === 'AED') {
      changeCurrency(1);
    } else {
      setIsProcessing(true);
      const reqHeaders = new Headers();
      const requestOptions = {
        method: 'GET',
        headers: reqHeaders
      };
      const url = new URL(`${apiURL}/api/currencyapi/exchangerates`);
      const queryString = new URLSearchParams({
        from: 'AED',
        to: currencyName
      });
      url.search = queryString.toString();
      fetch(url.toString(), requestOptions).then(response => response.status === 200 ? response.json() : null).then(data => {
        const responseReducedObj = Object.values(data)[0];
        changeCurrency(responseReducedObj.val);
        setIsProcessing(false);
      }).catch(error => {
        changeCurrencyName('AED');
        changeCurrency(1);
        localStorage.setItem(LOCAL_STORAGE_APP_CURRENCY, 'AED');
        console.error(error);
        setIsProcessing(false);
      });
    }
  }, [currencyName, apiURL, changeCurrencyName, changeCurrency]);
  useEffect(() => {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  if (!options.length) {
    return null;
  }
  const handleChange = event => {
    setFieldOpened(false);
    changeCurrencyName(event.value);
    localStorage.setItem(LOCAL_STORAGE_APP_CURRENCY, event.value);
  };
  const handleFocus = () => {
    if (!clickedFieldRef.current) {
      setHighLightField(true);
    }
  };
  const handleMousedown = () => {
    clickedFieldRef.current = true;
    setFieldOpened(!fieldOpened);
  };
  const handleTouchstart = e => {
    const dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      setFieldOpened(!fieldOpened);
    }
  };
  const handleBlur = () => {
    clickedFieldRef.current = false;
    setHighLightField(false);
    setFieldOpened(false);
  };
  const handleKeyDown = e => {
    if (e.which === 13 || e.which === 32) {
      setFieldOpened(!fieldOpened);
      if (!fieldOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setFieldOpened(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    style: colorSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: `
      input-wrapper
      ${fieldOpened ? 'input-wrapper--opened' : ''}
      ${isProcessing ? 'input-wrapper--disabled' : ''}
    `
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-primary lr__dd",
    onMouseDown: handleMousedown,
    onTouchStart: handleTouchstart
  }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    name: "dealsCurrenncySelector",
    id: "dealsCurrenncySelector",
    options: options,
    value: options.find(item => item.value === currencyName),
    className: `react-custom-select ${highLightField ? 'react-custom-select--outlined' : ''}`,
    onChange: handleChange,
    onFocus: handleFocus,
    onMouseDown: handleMousedown,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    "aria-label": "Deals select currency",
    "aria-labelledby": "Deals select currency",
    menuIsOpen: fieldOpened
  })))));
};
export default CurrencySelector;
const commonStyles = "cppexqa";
const ltrStyles = "l1moz8o3";
const rtlStyles = "r1q6osd2";